import React from 'react';

export const NappIcon = ({ name, color = "black", title, style = {}, onClick = () => { }, size = 12 }) =>
  <i title={title} className={"fas fa-" + name} onClick={onClick} style={{ ...style, fontSize: size * 3, color }}></i>